import { usePortalSession } from '../auth';

import type { GetMeResponse } from '../types/api';

export type PortalStatusState =
  | { status: 'loading' }
  | { status: 'online'; data: GetMeResponse }
  | { status: 'authenticationRequired'; message: string }
  | { status: 'forbidden'; message: string }
  | { status: 'serverError'; message: string }
  | { status: 'offline'; message: string };

export function usePortalStatus(): PortalStatusState {
  const session = usePortalSession();

  switch (session.status) {
    case 'loading':
      return { status: 'loading' };
    case 'ready':
      return session.response
        ? { status: 'online', data: session.response }
        : {
            status: 'serverError',
            message: 'The portal returned no session data.',
          };
    case 'signedOut':
      return {
        status: 'authenticationRequired',
        message:
          'Sign in with your email address to connect to the portal.',
      };
    case 'forbidden':
      return {
        status: 'forbidden',
        message:
          session.message ??
          'The signed-in user does not have access to the API.',
      };
    case 'error':
      return {
        status: 'serverError',
        message:
          session.message ??
          'The portal profile could not be loaded.',
      };
  }
}
